export const TOGGLE_IDENTITY_SELECTION =
  'my-faces-filter/TOGGLE_IDENTITY_SELECT';
export const RESET_IDENTITY_SELECTION =
  'my-faces-filter/RESET_IDENTITY_SELECTION';

export const toggleIdentitySelection = identity => {
  return { type: TOGGLE_IDENTITY_SELECTION, identity };
};

export const resetIdentitySelection = () => {
  return { type: RESET_IDENTITY_SELECTION };
};
